import { Pipe, PipeTransform } from '@angular/core';
import { flatMap } from 'rxjs';

@Pipe({
  name: 'relativeDate',
  standalone: false
})
export class RelativeDatePipe implements PipeTransform {

  transform(value: any): string {
    if (!value) return '';

    const fechaEntrada = new Date(value);
    if (isNaN(fechaEntrada.getTime())) return '';

    const hoy = new Date();
    hoy.setHours(0, 0, 0, 0);

    const fechaComparar = new Date(fechaEntrada.getTime());
    fechaComparar.setHours(0, 0, 0, 0);

    const diferenciaTiempo = fechaComparar.getTime() - hoy.getTime();
    const diferenciaDias = Math.round(diferenciaTiempo / (1000 * 60 * 60 * 24));

    switch (diferenciaDias) {
      case 0:
        return 'Hoy';
      case 1:
        return 'Mañana';
      case -1:
        return 'Ayer';
      default:
        return ''; // 🔥 CAMBIO: Si no es ninguno, devuelve vacío.
    }
  }
}